import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { switchMap } from "rxjs";
import { Applicant } from "src/app/core/models/applicant.model";
import { Application } from "src/app/core/models/application.model";
import { ApplicationService } from "src/app/core/services/application.services";
import { EnumService } from "src/app/core/services/enum.service";
import { UserService } from "src/app/core/services/user.service";
import { Lightbox } from "ngx-lightbox";
import { MatDialog } from "@angular/material/dialog";
import { BreakDownFeesPaymentComponent } from "src/app/dashboard/dashboard-components/new-application/components/break-down-fees-payment/break-down-fees-payment.component";
import { MoreInfoModalComponent } from "src/app/shared/more-info-modal/more-info-modal.component";
import { EvaluatorFileDetailsComponent } from "../evaluator-file-details/evaluator-file-details.component";
import { FileDetailsComponent } from "src/app/shared/file-details/file-details.component";
import { EvaluatorService } from "src/app/core/services/evaluator.service";
import { FileUploadComponent } from "src/app/shared/file-upload/file-upload.component";
import { EvaluatorActionsService } from "../../shared/services/evaluator-actions.service";
import { EvaluatorReturnModalComponent } from "../evaluator-return-modal/evaluator-return-modal.component";
import { EvaluatorUploadLabresultComponent } from "../evaluator-upload-labresult/evaluator-upload-labresult.component";
import { RemarksModalComponent } from "src/app/shared/remarks-modal/remarks-modal.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ApiService } from "src/app/core/services/api-service";
import { BcpoFileModalComponent } from "../bcpo-file-modal/bcpo-file-modal.component";
import { HttpClient } from "@angular/common/http";
import Swal from "sweetalert2";
import { ViewPdfModalComponent } from "src/app/shared/view-pdf-modal/view-pdf-modal.component";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ViewLabResultDetailsComponent } from "../view-lab-result-details/view-lab-result-details.component";
import { ViewLabResultsHistoryComponent } from "../view-lab-results-history/view-lab-results-history.component";

import { FormBuilder, FormGroup } from "@angular/forms";
import { ForObservationDialogComponent } from "../for-observation-dialog/for-observation-dialog.component";

export interface BreakDownFees {
  receiptNumber: string;
  receiptTypeName: string;
  dateIssued: Date;
  amountPaid: number;
}

@Component({
  selector: "app-evaluator-view-application",
  templateUrl: "./evaluator-view-application.component.html",
  styleUrls: ["./evaluator-view-application.component.scss"],
})
export class EvaluatorViewApplicationComponent implements OnInit {
  filesStool: File[] = [];
  filesXRay: File[] = [];
  filesRPR: File[] = [];
  evaluatorDetails;
  applicationDetails: Application;
  applicantDetails: Applicant;
  // applicationDocuments: any[];
  isLoading: boolean = false;
  applicationStatusEnum: any;
  permitTypeEnum: any;
  statusDescriptionEnum: any;
  animation: any;
  hasWorkingPermit;
  hasHealthCard;
  hasSeminarCert;
  evaluatorRole;
  applicationQrCode: string;
  album: Array<any> = [];
  displayedColumns: string[] = ["name", "date", "status", "remarks", "action"];
  // Receipt Number
  dataSourceBreakDownFees: BreakDownFees[] = [];
  displayedColumnsBreakDownFees: string[] = [
    "ReceiptNo",
    "receiptType",
    "Date Issued",
    "Amount",
  ];
  pdfSrc;
  cmoPdf;
  supportingFiles;
  supportingFilesColumns: string[] = ["name", "date", "action"];
  timeline;
  groupedTimelineData: any = {};
  safeHtmlContent: SafeHtml;
  nsrpFormPdf;
  hasSyphilis: boolean;
  hasPinkCard: boolean;
  hasBlueCard: boolean;
  hasNsrpForm: boolean;

  seminarForm: FormGroup;
  showDatePicker = false;
  showSeminarContainer: boolean = false;
  maxDate: Date;
  expirationDate: Date | null = null;

  constructor(
    private route: ActivatedRoute,
    private applicationService: ApplicationService,
    private userService: UserService,
    private enumService: EnumService,
    private lightbox: Lightbox,
    private dialog: MatDialog,
    private evaluatorService: EvaluatorService,
    private evaluatorActions: EvaluatorActionsService,
    private _snackBar: MatSnackBar,
    private api: ApiService,
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder
  ) {
    this.seminarForm = this.fb.group({
      attendedSeminar: [""],
      seminarDate: [" "],
    });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.evaluatorDetails = JSON.parse(
      localStorage.getItem("evaluator_details")
    );
    this.evaluatorRole = this.evaluatorDetails.role.role;
    const applicationId = this.route.snapshot.paramMap.get("id");
    this.applicationStatusEnum = this.enumService.getApplicationStatusEnum();
    this.permitTypeEnum = {
      1: "Food Handler",
      2: "Non Food Handler",
      3: "Entertainer (Female)",
      4: "Entertainer (Male)",
    };
    this.statusDescriptionEnum = this.enumService.getStatusDescrition();
    this.applicationService
      .getApplicationDetails(applicationId)
      .pipe(
        switchMap((res) => {
          this.applicationDetails = res.data;

          if (this.applicationDetails.seminarScheduleDate) {
            this.calculateExpirationDate();
          }

          this.applicationDetails.caseDisposition = this.applicationDetails
            .caseDisposition
            ? this.applicationDetails.caseDisposition
            : "N/A";
          this.applicationDetails.crimeChargedWith = this.applicationDetails
            .crimeChargedWith
            ? this.applicationDetails.crimeChargedWith
            : "N/A";
          this.fetchTimeline();
          this.safeHtmlContent = this.sanitizer.bypassSecurityTrustHtml(
            this.applicationDetails.applicantNotification
          );
          this.applicationQrCode = res.data.id;
          const applicantId = this.applicationDetails.applicantId;
          return this.userService.getApplicantDetails(applicantId);
        })
      )
      .subscribe((applicantDetails) => {
        this.applicantDetails = applicantDetails;
        this.maxDate = new Date();
        if (this.evaluatorRole === "CHSO-DOC") {
          this.showSeminarContainer =
            (this.applicationDetails.isAttendedSeminar === null ||
              this.applicationDetails.isAttendedSeminar === undefined ||
              this.applicationDetails.isAttendedSeminar === false) &&
            (this.applicationDetails.workingPermitType === 3 ||
              this.applicationDetails.workingPermitType === 4);

          this.seminarForm
            .get("seminarDate")
            ?.valueChanges.subscribe((selectedDate) => {
              if (selectedDate) {
                this.applicationDetails.seminarScheduleDate = selectedDate;
                this.calculateExpirationDate();              }
            });
        }

        this.evaluatorService
          .getApplicationFiles(this.applicationDetails.id)
          .subscribe((res) => {
            this.dataSourceBreakDownFees =
              this.applicationDetails.officialReceipts;
            this.fetchSupportingFiles();
            this.isLoading = false;
          });
      });
    const savedDate = localStorage.getItem("seminarScheduleDate");
    if (savedDate) {
      this.applicationDetails.seminarScheduleDate = new Date(savedDate);
      this.calculateExpirationDate();
    }

    this.seminarForm
      .get("seminarDate")
      ?.valueChanges.subscribe((selectedDate) => {
        if (selectedDate) {
          this.applicationDetails.seminarScheduleDate = selectedDate;
          this.calculateExpirationDate();
        }
      });
  }

  onSeminarAttendanceChange() {
    const attendedSeminar = this.seminarForm.get("attendedSeminar")?.value;
    this.applicationDetails.isAttendedSeminar = attendedSeminar === "true";

    this.showDatePicker = this.applicationDetails.isAttendedSeminar;

    if (this.applicationDetails.isAttendedSeminar) {
      this.applicationDetails.seminarScheduleDate =
        this.seminarForm.get("seminarDate")?.value;
    } else {
      this.applicationDetails.seminarScheduleDate = "";
    }

  }

  calculateExpirationDate() {
    if (this.applicationDetails.seminarScheduleDate) {
      const seminarDate = new Date(this.applicationDetails.seminarScheduleDate);
      seminarDate.setFullYear(seminarDate.getFullYear() + 4);
      this.expirationDate = seminarDate;
      localStorage.setItem("seminarScheduleDate", seminarDate.toISOString());
    } else {
      console.error(
        "seminarScheduleDate is invalid:",
        this.applicationDetails.seminarScheduleDate
      );
    }
  }

  getApplicationStatusDescription(status: number): string {
    return this.applicationStatusEnum[status];
  }

  getPermitType(status: number): string {
    return this.permitTypeEnum[status];
  }

  getStatusDescription(status: number): string {
    return this.statusDescriptionEnum[status];
  }

  openLightBox(files) {
    this.album = [];
    for (const f of files) {
      this.album.push({
        src: f.fullPath,
        caption: f.fileName,
        thumb: f.fullPath,
      });
    }
    this.lightbox.open(this.album);
  }
  getOccupation(workingPermitType: number, occupation: string): string {
    if (workingPermitType === 3 || workingPermitType === 4) {
      return 'Entertainer';
    }
    return occupation || 'Not specified';
  }


  openMoreInfo() {
    const dialogRef = this.dialog.open(MoreInfoModalComponent, {
      data: this.applicantDetails,
      maxWidth: "100vw",
      maxHeight: "100vh",
      height: "100%",
      width: "100%",
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  onEvaluate(file) {
    const dialogRef = this.dialog.open(FileDetailsComponent, {
      maxHeight: "90vh",
      width: "90vw",
      data: {
        application: this.applicationDetails,
        file: file,
        evaluator: this.evaluatorDetails,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }

  approve() {
    Swal.fire({
      title: "Are you sure?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "#e74c3c",
      confirmButtonColor: "#4DAF50",
    }).then((result) => {
      this.isLoading = true;

      if (result.isConfirmed) {
        const attendedSeminarValue =
          this.seminarForm.get("attendedSeminar")?.value;
        if (
          this.evaluatorRole === "CHSO-SAN" &&
          this.applicationDetails.seminarSchedules[0]?.isAttended == false &&
          this.applicationDetails.applicationType === 1
        ) {
          this._snackBar.open("Food Handler Seminar Not Attended", "close");
          this.isLoading = false;
        } else {
          if (
            this.applicationDetails.workingPermitType === 3 ||
            this.applicationDetails.workingPermitType === 4
          ) {
            this.applicationService
              .updateApplicantDetails(this.applicationDetails.id, {
                isAttendedSeminar: attendedSeminarValue === "true",
                seminarScheduleDate:
                  this.applicationDetails.seminarScheduleDate,
              })
              .subscribe(
                () => {
                  this.approveForm(1, "Compliant").subscribe((res) => {
                    this._snackBar.open("Success!", "close");
                    setTimeout(() => {
                      window.location.reload();
                    }, 2000);
                  });
                },
                (error) => {
                  console.error("Error updating applicant details:", error);
                  this._snackBar.open("Failed to update details", "close");
                  this.isLoading = false;
                }
              );
          } else {
            this.approveForm(1, "Compliant").subscribe((res) => {
              this._snackBar.open("Success!", "close");
              setTimeout(() => {
                window.location.reload();
              }, 2000);
            });
          }
        }
      } else {
        this.isLoading = false;
      }
    });
  }

  handleAttendance() {
    Swal.fire({
      title: "Are you sure you want to mark as Attended?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "#e74c3c",
      confirmButtonColor: "#4DAF50",
    }).then((result) => {
      this.isLoading = true;
      if (result.isConfirmed) {
        const body = {
          applicationId: this.applicationDetails.id,
          timeslotId: this.applicationDetails.seminarSchedules[0].timeslotId,
          isAttended: true,
        };
        this.evaluatorService.updateAttendance(body).subscribe((res) => {
          this.isLoading = false;
          window.location.reload();
        });
      } else if (result.isDenied) {
        this.isLoading = false;
        return;
      }
    });
  }

  approveForm(id: number, reason: string) {
    const formData: FormData = new FormData();
    formData.append("EvalStatus", `${id}`);
    formData.append("ReasonForChange", `${reason}`);
    formData.append("NonCompliantType", "0");
    formData.append("CourtClearanceNumber", "");
    formData.append("PoliceClearanceType", "");

    const url = `/evaluator/update-status/${this.applicationDetails.id}`;

    return this.api.put(url, formData);
  }

  toBcpo() {
    const body = {
      applicationStatus: 21,
    };
    this.evaluatorService
      .updateApplicationStatus(body, this.applicationDetails.id)
      .subscribe((res) => {
        window.location.reload();
      });
  }

  upload(type) {
    const dialogRef = this.dialog.open(FileUploadComponent, {
      height: "90vh",
      width: "70vw",
      data: {
        type: type,
        evaluator: this.evaluatorDetails,
        application: this.applicationDetails,
        applicant: this.applicantDetails,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.fetchSupportingFiles();
    });
  }

  fetchSupportingFiles() {
    this.evaluatorService
      .getApplicationSupportingFiles(this.applicationDetails.id)
      .subscribe((res) => {
        this.supportingFiles = res.data;
        const latestDocumentsMap = res.data.reduce((acc, currentDoc) => {
          const existingDoc = acc[currentDoc.fileType];
          if (
            !existingDoc ||
            new Date(currentDoc.createdDate) > new Date(existingDoc.createdDate)
          ) {
            acc[currentDoc.fileType] = currentDoc;
          }
          return acc;
        }, {});
        this.supportingFiles = Object.values(latestDocumentsMap);
        if (this.applicationDetails.policeClearanceFilePath.includes("pdf"))
          this.supportingFiles.push({
            fileDescription: "Police Clearance",
            fileUrl: this.applicationDetails.policeClearanceFilePath,
            createdDate: new Date(),
          });

        this.hasWorkingPermit = this.supportingFiles.find(
          (e) => e.fileType == 0
        );
        this.hasHealthCard = this.supportingFiles.find(
          (e) => e.fileType == 1 || e.fileType == 2
        );
        this.hasSeminarCert = this.supportingFiles.find(
          (e) => e.fileType == -1
        );
        this.hasPinkCard = this.supportingFiles.find((e) => e.fileType == 3);
        this.hasBlueCard = this.supportingFiles.find((e) => e.fileType == 4);
        this.hasNsrpForm = this.supportingFiles.find((e) => e.fileType == 5);
        if (
          this.applicationDetails.workingPermitType !== 3 &&
          this.applicationDetails.workingPermitType !== 4
        ) {
        } else {
          this.hasSyphilis = this.applicationDetails.hasExistingRPRResult;
        }
      });
  }

  hasLaboratoriesCleared() {
    if (
      this.applicationDetails.workingPermitType !== 3 &&
      this.applicationDetails.workingPermitType !== 4
    ) {
      return true;
    } else {
      return true;
    }
  }

  hasLaboratoriesNotCleared() {
    if (
      this.applicationDetails.workingPermitType !== 3 &&
      this.applicationDetails.workingPermitType !== 4
    ) {
      return true;
    } else return true;
  }

  handleEvaluatorReturn() {
    const dialogRef = this.dialog.open(EvaluatorReturnModalComponent, {
      width: "700px",
      data: {
        application: this.applicationDetails,
        evaluator: this.evaluatorDetails,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      window.location.reload();
    });
  }

  onUpload(doc) {
    const dialogRef = this.dialog.open(EvaluatorUploadLabresultComponent, {
      width: "70vw",
      data: doc,
    });

    dialogRef.afterClosed().subscribe((result) => {
      window.location.reload();
    });
  }

  getCHSOStatus(): string {
    const arr = [
      this.applicationDetails.chsoLabStatus,
      this.applicationDetails.chsoDoctorStatus,
      this.applicationDetails.chsoSanStatus,
    ];

    if (arr.every((status) => status === 3)) {
      return "Compliant";
    } else if (arr.some((status) => status === 2)) {
      return "Non-Compliant";
    } else if (arr.some((status) => status === 0)) {
      return "Pending";
    }
  }

  handleLabUpload() {
    const dialogRef = this.dialog.open(EvaluatorUploadLabresultComponent, {
      width: "70vw",
      maxHeight: "90vh",
      data: {
        isHsoEvaluator: true,
        applicationId: this.applicationDetails.id,
        isNightEstablishment: this.applicationDetails.worksAtNightEstablishment,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      window.location.reload();
    });
  }

  handleForObservation() {
    const dialogRef = this.dialog.open(ForObservationDialogComponent, {
      data: {
        application: this.applicationDetails,
      },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  viewRemarks(doc) {
    const dialogRef = this.dialog.open(RemarksModalComponent, {
      width: "600px",
      data: doc,
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  isImage(filePath: string): boolean {
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
    return allowedExtensions.test(filePath);
  }

  forBcpoProcessing() {
    Swal.fire({
      title: "Are you sure?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "#e74c3c",
      confirmButtonColor: "#4DAF50",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        this.bcpoForm().subscribe((res) => {
          this.isLoading = false;
          window.location.reload();
        });
      } else {
        this.isLoading = false;
        return;
      }
    });
  }

  bcpoForm() {
    const formData: FormData = new FormData();
    formData.append("EvalStatus", "3");
    formData.append("ReasonForChange", "For Processing");
    formData.append("NonCompliantType", "0");
    formData.append("CourtClearanceNumber", "");
    formData.append("PoliceClearanceType", "");

    const url = `/evaluator/update-status/${this.applicationDetails.id}`;

    return this.api.put(url, formData);
  }

  forBcpoApprove() {
    const dialogRef = this.dialog.open(BcpoFileModalComponent, {
      width: "600px",
      data: this.applicationDetails,
    });

    dialogRef.afterClosed().subscribe((result) => {
      window.location.reload();
    });
  }

  pesoApprove() {
    Swal.fire({
      title: "Are you sure?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "#e74c3c",
      confirmButtonColor: "#4DAF50",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        this.evaluatorApprove("1").subscribe((res) => {
          this._snackBar.open("Approved!", "close");
          this.isLoading = false;
          window.location.reload();
        });
      } else {
        this.isLoading = false;
        return;
      }
    });
  }

  cmoApprove() {
    this.isLoading = true;
    const body = {
      applicationId: this.applicationDetails.id,
    };
    this.evaluatorService
      .generateSignature(this.evaluatorDetails.id, body)
      .subscribe((res) => {
        const png = res.imagePath;
        const doc = this.supportingFiles.find((e) => e.fileType == 0);
        this.evaluatorService.insertSignature(doc.fileUrl, png).then((blob) => {
          const body = {
            ApplicationId: this.applicationDetails.id,
            FileDescription: "Working Permit",
            FileType: 0,
            FileSize: "",
            AccessLevel: "",
          };
          const file = new File(
            [blob],
            `${this.applicationDetails.apn}` + "-working-permit",
            { type: blob.type }
          );
          body["File"] = file;
          this.evaluatorService.uploadSupportFile(body).subscribe((res) => {
            this.evaluatorApprove("1").subscribe((res) => {
              this._snackBar.open("Approved!", "close");
              this.isLoading = false;
              window.location.reload();
            });
          });
        });
      });
  }

  pesoRelease() {
    this.isLoading = true;
    Swal.fire({
      title: "Are you sure?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "#e74c3c",
      confirmButtonColor: "#4DAF50",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        this.evaluatorApprove("5").subscribe((res) => {
          this._snackBar.open("Approved!", "close");
          this.isLoading = false;
          window.location.reload();
        });
      } else {
        this.isLoading = false;
        return;
      }
    });
  }

  viewPdf(pdf) {
    const dialogRef = this.dialog.open(ViewPdfModalComponent, {
      height: "90vh",
      width: "70vw",
      data: {
        pdf: pdf,
        application: this.applicationDetails,
        applicant: this.applicantDetails,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.fetchSupportingFiles();
    });
  }

  evaluatorApprove(status) {
    const formData: FormData = new FormData();
    formData.append("EvalStatus", status);

    const url = `/evaluator/update-status/${this.applicationDetails.id}`;

    return this.api.put(url, formData);
  }

  private async fetchFile(path: string, filename): Promise<File> {
    try {
      const response = await this.httpClient
        .get(path, { responseType: "blob" })
        .toPromise();
      return new File([response], filename, { type: "application/pdf" });
    } catch (error) {
      console.error("Error fetching file:", error);
      return null;
    }
  }

  isDocumentsCleared() {
    if (
      this.applicationDetails.workingPermitType !== 3 &&
      this.applicationDetails.workingPermitType !== 4
    ) {
      return true;
    } else {
      return true;
    }
  }

  isDocumentsEvaluated() {
    if (
      this.applicationDetails.workingPermitType !== 3 &&
      this.applicationDetails.workingPermitType !== 4
    ) {
      return true;
    } else return true;
  }

  fetchTimeline() {
    this.applicationService
      .getApplicationTimeline(this.applicationDetails.id)
      .subscribe((res) => {
        this.timeline = res.data;
        const hsoCategories = [
          "Laboratory",
          "Doctor's Office",
          "Sanitation Office",
        ];
        this.groupedTimelineData = {
          Applicant: [],
          HSO: [],
          BCPO: [],
          PESO: [],
          CMO: [],
        };

        this.timeline.forEach((item) => {
          if (hsoCategories.includes(item.name)) {
            this.groupedTimelineData["HSO"].push(item);
          } else {
            this.groupedTimelineData[item.name]?.push(item);
          }
        });
      });
  }

  onViewDetails(e) {
    const dialogRef = this.dialog.open(ViewLabResultDetailsComponent, {
      maxHeight: "90vh",
      width: "90vw",
      data: e,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }

  onViewHistory(e) {
    const dialogRef = this.dialog.open(ViewLabResultsHistoryComponent, {
      maxHeight: "90vh",
      width: "100vw",
      data: e,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.ngOnInit();
    });
  }

  handleRequireSyphilis() {
    Swal.fire({
      title: "Are you sure?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "#e74c3c",
      confirmButtonColor: "#4DAF50",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        this.fileUpload().subscribe((res) => {
          const body = {
            status: 2,
            remark: "Please upload Syphilis Test",
          };

          this.evaluatorService
            .fileReview(body, res.applicationId, res.id)
            .subscribe((res) => {
              this.isLoading = false;
              this._snackBar.open("Success!", "close");
              window.location.reload();
            });
        });
      } else {
        this.isLoading = false;
        return;
      }
    });
  }

  fileUpload() {
    const formData: FormData = new FormData();
    const file = "../../../../assets/documents/upload-syphilis.png";

    return this.httpClient.get(file, { responseType: "blob" }).pipe(
      switchMap((blob) => {
        formData.append("ApplicationId", this.applicationDetails.id.toString());
        formData.append("ResultType", "3");
        formData.append("Files", blob, "upload-syphilis.png");

        const url = `/evaluator/application/${this.applicationDetails.id}/labresult`;

        return this.api.post(url, formData);
      })
    );
  }
}
